import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["desc", "headerGradient", "headerLink", "headerProps", "headerSubtitle", "headerTitle", "isLoading", "link", "refreshAction", "theme", "title"];
import React from 'react';
import classNames from 'classnames/bind';
import { Refresh, S7Circle } from "../icons";
import { TextBase } from "../internal/TextBase";
import { gradients, themes } from './constants';
import styles from './PriorityStatus.css';
var cx = classNames.bind(styles);

var PriorityStatus = function PriorityStatus(_ref) {
  var _cx;

  var desc = _ref.desc,
      _ref$headerGradient = _ref.headerGradient,
      headerGradient = _ref$headerGradient === void 0 ? gradients[0] : _ref$headerGradient,
      headerLink = _ref.headerLink,
      headerProps = _ref.headerProps,
      headerSubtitle = _ref.headerSubtitle,
      headerTitle = _ref.headerTitle,
      isLoading = _ref.isLoading,
      link = _ref.link,
      refreshAction = _ref.refreshAction,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? themes[0] : _ref$theme,
      title = _ref.title,
      rest = _objectWithoutProperties(_ref, _excluded);

  var handleRefresh = function handleRefresh(e) {
    e.preventDefault();

    if (refreshAction) {
      refreshAction(e);
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    className: cx('root', {
      has_header: headerTitle
    })
  }, headerTitle && /*#__PURE__*/React.createElement("a", _extends({}, headerProps, {
    className: cx('header', "gradient_".concat(headerGradient)),
    href: headerLink
  }), /*#__PURE__*/React.createElement(TextBase, {
    as: "span",
    color: "W100",
    size: "l",
    weight: "semibold"
  }, headerTitle), /*#__PURE__*/React.createElement(TextBase, {
    as: "span",
    color: "W100",
    size: "s"
  }, headerSubtitle)), /*#__PURE__*/React.createElement("a", _extends({
    href: link,
    className: cx('status', (_cx = {}, _defineProperty(_cx, "status_theme_".concat(theme), theme), _defineProperty(_cx, "disabledLink", !link), _cx))
  }, rest), /*#__PURE__*/React.createElement("div", {
    className: cx('icon')
  }, /*#__PURE__*/React.createElement(S7Circle, null)), /*#__PURE__*/React.createElement("div", {
    className: cx('content')
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('title')
  }, title), desc ? /*#__PURE__*/React.createElement("div", {
    className: cx('desc')
  }, desc) : null), refreshAction ? /*#__PURE__*/React.createElement("button", {
    onClick: handleRefresh,
    className: cx('refresh'),
    type: "button"
  }, "refresh", /*#__PURE__*/React.createElement(Refresh, {
    classes: {
      root: cx({
        isLoading: isLoading
      })
    }
  })) : null));
};

export default PriorityStatus;